import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/src/components/ui/select";
import { useTranslation } from "@/src/i18n/client";
import { Label } from "../ui/label";

interface TaskOption {
  id: string;
  name: string;
  description?: string;
}

interface TaskSelectProps {
  value: string;
  onValueChange: (value: string) => void;
  tasks: TaskOption[];
  isLoading: boolean;
}

export function TaskSelect({
  value,
  onValueChange,
  tasks,
  isLoading,
}: TaskSelectProps) {
  const { t } = useTranslation();
  
  // Find the selected task to display its label
  const selectedTask = tasks.find(task => task.id === value);
  const displayValue = selectedTask ? (selectedTask.description ?? selectedTask.name) : undefined;
  
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
     <Label
        htmlFor="task-select"
        className="block text-sm font-medium text-gray-900 dark:text-white mb-0 w-full sm:w-28"
      >
        {t('homePage.taskSelect.label')}
      </Label>
      <div className="w-full sm:flex-1 min-w-0">
        <Select
          value={value}
          onValueChange={(value) => value && onValueChange(value)}
          disabled={isLoading || tasks.length === 0}
        >
          <SelectTrigger
            id="task-select"
            className="w-full min-w-0 rounded-md border border-input bg-background px-3 py-2 text-sm text-foreground shadow-sm focus:border-primary focus:ring-2 focus:ring-primary/20 dark:bg-background dark:text-foreground dark:border-input"
          >
            {displayValue || <span className="text-muted-foreground">{isLoading ? t('homePage.taskSelect.loading') : t('homePage.taskSelect.placeholder')}</span>}
          </SelectTrigger>
          <SelectContent
            className="rounded-md border border-input bg-background shadow-lg dark:bg-background dark:border-input"
          >
            {tasks.map((task) => (
              <SelectItem key={task.id} value={task.id} className="px-3 py-2 hover:bg-primary/10 dark:hover:bg-primary/20">
                {task.description ?? task.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
